import { Progress } from "../../../../nq-component";
import { useEffect } from "react";

const SummaryCard = ({ title, value, change, isPositive, progress }) => {
  useEffect(() => {}, [progress]);

  return (
    <div className="p-4">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <span className="text-muted small">{title}</span>
        {change && (
          <span
            className={`small ${isPositive ? "text-success" : "text-danger"}`}
          >
            {isPositive ? "+" : ""}
            {change}%
          </span>
        )}
      </div>
      <h4 className="h3 fw-bold text-dark mb-0">{progress ? 0 : value || 0}</h4>
    </div>
  );
};

export default SummaryCard;
